var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 18.3333L13.3334 5H6.66675L14.1764 20.7703M20.0001 18.3333L26.6667 5H33.3334L25.8237 20.7703M20.0001 18.3333C22.24 18.3333 24.3081 19.2725 25.8237 20.7703M20.0001 18.3333C17.7601 18.3333 15.6921 19.2725 14.1764 20.7703M25.8237 20.7703C27.3638 22.2922 28.3334 24.3907 28.3334 26.6667C28.3334 31.269 24.6025 35 20.0001 35C15.3977 35 11.6667 31.269 11.6667 26.6667C11.6667 24.3907 12.6364 22.2922 14.1764 20.7703",
    stroke: "#F09C3A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalIcon);
export default __webpack_public_path__ + "static/media/medalIcon.f0ce1da2e99173243262233c680ec126.svg";
export { ForwardRef as ReactComponent };